var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.boundaries),function(boundary,index){return _c('BasePolygon',{key:'boundary-' + index,attrs:{"boundary":boundary.coordinates[0].map(_vm.getLatLng),"popup":_vm.popup,"tooltip":_vm.tooltip},on:{"click":_vm.onClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }